/**
 * BackendSelector component for choosing backend server
 */
import { useState, useEffect } from 'react';

interface BackendSelectorProps {
    value: string;
    onChange: (backend: string) => void;
}

export function BackendSelector({ value, onChange }: BackendSelectorProps) {
    const [backend, setBackend] = useState(value);

    useEffect(() => {
        setBackend(value);
    }, [value]);

    return (
        <select
            value={backend}
            onChange={(e) => onChange(e.target.value)}
            className="backend-selector"
        >
            <option value="local">Local Backend</option>
            <option value="cloud">Cloud Backend</option>
        </select>
    );
}
